var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EEF0F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3643_17255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5271 28.9038L32.6625 20.7684L31.1729 19.3018L23.0604 27.4372L24.5271 28.9038ZM18.0188 30.4393C16.4299 30.3323 15.2573 29.9809 14.5011 29.3851C13.7448 28.7893 13.3667 27.9948 13.3667 27.0018C13.3667 26.0545 13.7486 25.2792 14.5125 24.6757C15.2764 24.0722 16.3611 23.6636 17.7667 23.4497C18.5306 23.358 19.0577 23.2358 19.3479 23.083C19.6382 22.9302 19.7834 22.724 19.7834 22.4643C19.7834 22.0976 19.5466 21.8035 19.0729 21.582C18.5993 21.3604 17.866 21.1962 16.8729 21.0893L17.0334 19.2101C18.5306 19.3476 19.6841 19.6952 20.4938 20.2528C21.3035 20.8104 21.7084 21.5476 21.7084 22.4643C21.7084 23.1976 21.4028 23.8125 20.7917 24.309C20.1806 24.8056 19.325 25.1455 18.225 25.3288C17.2625 25.4511 16.533 25.6535 16.0365 25.9361C15.54 26.2188 15.2917 26.5816 15.2917 27.0247C15.2917 27.4677 15.5247 27.8115 15.9907 28.0559C16.4566 28.3004 17.1632 28.4531 18.1104 28.5143L18.0188 30.4393ZM25.1229 31.0351L20.8834 26.8184L31.1729 16.5518L35.4125 20.7684L25.1229 31.0351ZM25.1229 31.0351L19.8063 32.1351L20.8834 26.8184L25.1229 31.0351Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3643_17255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAppointmentIcon);
export default __webpack_public_path__ + "static/media/EditAppointmentIcon.48c0019cde126869a6650c95257213aa.svg";
export { ForwardRef as ReactComponent };